import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Roadmap } from 'shared/assets/icons';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './sub-goals-empty-state.style';

type SubgoalsEmptyStateProps = {
  onAdd: () => void;
  onHide: () => void;
};

export const SubGoalsEmptyState: React.FC<SubgoalsEmptyStateProps> = ({
  onAdd,
  onHide,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <Styled.IconContainer>
        <Icon icon={Roadmap} />
      </Styled.IconContainer>

      <Styled.Content>
        <Typography variant="subtitle2">
          {t('pages.goal-detail.roadmap.empty.title')}
        </Typography>
        <Styled.Description>
          {t('pages.goal-detail.roadmap.empty.description')}
        </Styled.Description>
      </Styled.Content>

      <Styled.Interactions>
        <Button
          variant={Variants.Contained}
          color={Colors.Primary}
          size={Sizes.Small}
          onClick={onAdd}
        >
          {t('pages.goal-detail.roadmap.empty.button')}
        </Button>

        <Button
          variant={Variants.Text}
          color={Colors.Primary}
          size={Sizes.Small}
          onClick={onHide}
        >
          {t('pages.goal-detail.roadmap.empty.caption')}
        </Button>
      </Styled.Interactions>
    </Styled.Container>
  );
};
